import { ArrowDropDown } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Bars3BottomLeftIcon, MoonIcon, SunIcon, XMarkIcon } from '@heroicons/react/24/solid'

import Logo from "../../assets/logo.jpeg";
import HeaderOptions from "./HeaderOptions";
import MobHeader from "./MobHeader";

const Header = ({ darkToggle, setDarkToggle }) => {
  const [isHover, setisHover] = useState('');
  const [mobNavOpen, setmobNavOpen] = useState(false)

  const navigate = useNavigate();

  const names = [
    "Services",
    "Industries",
    "Hire developers",
    "Content Hub",
    "Company",
    "Pricing",
  ];

  const handleClick = (item) => {
    if (item === "Pricing") {
      navigate("/pricing");
    }
  };

  useEffect(() => {

    localStorage.setItem('darkMode', darkToggle)

  }, [darkToggle])

  return (

    <nav className="bg-gradient-to-r from-gray-900 to-gray-800 fixed top-0 left-0 right-0 z-50">
      <div className="max-w-screen-2xl mx-auto px-2 md:px-5 py-2 flex items-center gap-3 justify-between xl:justify-self-auto">
        <Link to="/" onClick={() => window.scrollTo(0, 0)} className='flex items-center gap-2'>
          <div className=' h-[35px] md:h-[45px] w-[35px] md:w-[45px] hover:scale-90 duration-700 opacity-90 border-[4px] md:border-[5px] border-white rounded-full flex justify-center items-center'>
            <h1 className=' text-[14px] md:text-[18px] font-semibold text-white'>
              CZ
            </h1>
          </div>
          <p className="text-gray-100 text-sm ">Code<span className="font-bold text-green-500">Zone</span></p>
        </Link>
        <div className="hidden xl:flex lg:gap-4 xl:gap-7 grow justify-center">
          {names.map((item, i) => (
            <div
              className={`py-2 flex items-center cursor-pointer hover:scale-110 duration-700 ${isHover === item && 'scale-110'}`}
              key={i}
              onMouseEnter={() => setisHover(item)}
              onMouseLeave={() => setisHover("")}
            >
              <p
                onClick={() => handleClick(item)}
                className={`text-slate-100 text-xs 2xl:text-sm font-semibold hover:underline underline-offset-8 ${isHover === item && "underline"
                  }`}
              >
                {item}
              </p>

              {item !== "Pricing" && (
                <div className="flex items-center cursor-pointer ml-[-3px]">
                  <ArrowDropDown sx={{ color: "white", fontSize: "26px" }} />
                </div>
              )}
            </div>
          ))}
          {isHover && isHover !== "Pricing" && (
            <HeaderOptions setisHover={setisHover} title={isHover} />
          )}
        </div>
        <div>

          <div className="hidden xl:flex items-center gap-3 ">
            <div className="flex gap-2 items-center">

              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" checked={darkToggle} onChange={() => setDarkToggle(!darkToggle)} class="sr-only peer" />
                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 duration-1000 after:duration-500 peer-checked:bg-yellow-600"></div>
              </label>

              <div className="relative  w-5 h-5 cursor-pointer" onClick={() => setDarkToggle(!darkToggle)} >
                <SunIcon
                  className={`absolute top-0 left-0 w-full h-full text-yellow-400 transition-all duration-1000 ease-in-out ${!darkToggle ? "opacity-0" : ""} `}
                />
                <MoonIcon
                  className={`absolute top-0 left-0 w-full h-full text-gray-500 transition-all duration-1000 ease-in-out ${!darkToggle ? "" : "opacity-0"}`}
                />
              </div>
            </div>
            <button
              onClick={() => navigate('/contact-us')}
              className=" rounded-xl px-4 py-1 overflow-hidden relative group cursor-pointer border-2 font-medium text-[16px] border-yellow-500 text-black hover:scale-105 duration-[900ms]">
              <span className="absolute w-64 h-0 transition-all duration-[900ms] origin-center rotate-45 -translate-x-20 bg-yellow-600 top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
              <span className="relative text-yellow-500 transition duration-[900ms] group-hover:text-white ease">Contact Us</span>
            </button>
          </div>

          {/* Mobile Nav */}
          <div className="flex xl:hidden items-center gap-3 ">
            <div className="flex gap-2 items-center">

              <label class="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" checked={darkToggle} onChange={() => setDarkToggle(!darkToggle)} class="sr-only peer" />
                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 duration-1000 after:duration-500 peer-checked:bg-yellow-600"></div>
              </label>
              <div className="relative  w-[27px] h-[27px] cursor-pointer" onClick={() => setDarkToggle(!darkToggle)}>
                <SunIcon
                  className={`absolute top-0 left-0 w-full h-full text-yellow-400 transition-all duration-1000 ease-in-out ${!darkToggle ? "opacity-0" : ""} `}
                />
                <MoonIcon
                  className={`absolute top-0 left-0 w-full h-full text-gray-500 transition-all duration-1000 ease-in-out ${!darkToggle ? "" : "opacity-0"}`}
                />
              </div>
            </div>
            {!mobNavOpen ? (
              <div className="bg-white text-red-500 px-1 py-1 rounded-full " onClick={() => setmobNavOpen(true)}>
                <Bars3BottomLeftIcon className="h-[25px] sm:h-6" />
              </div>
            ) : (
              <div className="bg-white text-red-500 px-1 py-1 rounded-full" onClick={() => setmobNavOpen(false)}>
                <XMarkIcon className="h-[25px] sm:h-6" />
              </div>
            )}

            {mobNavOpen && (
              <MobHeader mobNavOpen={mobNavOpen} setmobNavOpen={setmobNavOpen} darkToggle={darkToggle} />
            )}

          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
